import { getFormLableStyleStr } from "../FormText/FormBaseStyle";
import { getPaddingString, formFieldErrorHtml, toRGBA } from "../parser/utils";

const INPUT_TYPE_MAPPING = {
  "form-date": "date",
  "form-number": "number",
};
export default ({ id, type, data, root }) => {
  const { label, placeholder, required } = data;

  const {
    formBorderWidth,
    formBorderStyle,
    formBorderColor,
    formBorderRadius,
    formTextColor
  } = root.data;

  const labelStyle = getFormLableStyleStr(data, root.data);

  return `
    <div class="rip-field-group" style="text-align: left;${getPaddingString(data)}">
      <label for="${id}" style="${labelStyle}">
        ${required ? '<span style="color: #ff4d4f; margin-right: 4px;">*</span>' : ""}${label}
      </label>
      <input
        id="${id}"
        name="${id}"
        class="rip-form-input"
        style="
          height: 38px;
          width: 100%;
          padding: 0 8px;
          border-width: ${formBorderWidth}px;
          border-style: ${formBorderStyle};
          border-color: ${toRGBA(formBorderColor)};
          border-radius: ${formBorderRadius}px;
          color: ${toRGBA(formTextColor)};
        "
        type="${INPUT_TYPE_MAPPING[type] || "text"}"
        placeholder="${placeholder}"
      />
      ${formFieldErrorHtml({ id })}
    </div>
  `;
};
